"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactRedux = require("react-redux");

var _apiAuthLogin_post = require("../actions/apiAuthLogin_post");

var _reactBootstrap = require("react-bootstrap");

var _reactLoadingOverlay = require("react-loading-overlay");

var _reactLoadingOverlay2 = _interopRequireDefault(_reactLoadingOverlay);

var _redux = require("redux");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _md = require("md5");

var md5 = _interopRequireWildcard(_md);

var _AuthLoginError = require("./AuthLoginError");

var _AuthLoginError2 = _interopRequireDefault(_AuthLoginError);

var _LoginIcon = require("mdi-react/LoginIcon");

var _LoginIcon2 = _interopRequireDefault(_LoginIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthLoginForm = function (_React$Component) {
	_inherits(AuthLoginForm, _React$Component);

	function AuthLoginForm(props) {
		_classCallCheck(this, AuthLoginForm);

		return _possibleConstructorReturn(this, (AuthLoginForm.__proto__ || Object.getPrototypeOf(AuthLoginForm)).call(this, props));
	}

	_createClass(AuthLoginForm, [{
		key: "handleLogin",
		value: function handleLogin() {
			var USERNAME = this.login_username.value;
			var PASSWORD = this.login_password.value;
			this.props.dispatch((0, _apiAuthLogin_post.apiAuthLogin_post)({
				USERNAME: USERNAME,
				PASSWORD: md5(PASSWORD)
			}));
		}
	}, {
		key: "handleSubmit",
		value: function handleSubmit(e) {
			e.preventDefault();
			this.handleLogin();
		}
	}, {
		key: "handleKeys",
		value: function handleKeys(e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				this.handleLogin();
			}
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_reactBootstrap.Modal,
				{ className: "AuthLoginForm",
					show: true,
					animation: false
				},
				_react2.default.createElement(
					_reactBootstrap.Modal.Header,
					null,
					_react2.default.createElement(
						_reactBootstrap.Modal.Title,
						null,
						"Bitte melden Sie sich an"
					)
				),
				_react2.default.createElement(
					_reactLoadingOverlay2.default,
					{
						animate: true,
						active: this.props.currentUser.loading,
						spinner: true,
						background: "rgba(0, 0, 0, 0.2)"
					},
					_react2.default.createElement(
						_reactBootstrap.Modal.Body,
						null,
						_react2.default.createElement(_AuthLoginError2.default, null),
						_react2.default.createElement(
							_reactBootstrap.Form,
							{ horizontal: true, onSubmit: this.handleSubmit.bind(this) },
							_react2.default.createElement(
								_reactBootstrap.FormGroup,
								null,
								_react2.default.createElement(
									_reactBootstrap.ControlLabel,
									{ className: "col-md-3 control-label" },
									"Username: "
								),
								_react2.default.createElement(
									_reactBootstrap.Col,
									{ md: 9 },
									_react2.default.createElement(_reactBootstrap.FormControl, {
										className: "form-control",
										placeholder: "Username",
										type: "text",
										inputRef: function inputRef(ref) {
											_this2.login_username = ref;
										}
									})
								)
							),
							_react2.default.createElement(
								_reactBootstrap.FormGroup,
								null,
								_react2.default.createElement(
									_reactBootstrap.ControlLabel,
									{ className: "col-md-3 control-label" },
									"Passwort: "
								),
								_react2.default.createElement(
									_reactBootstrap.Col,
									{ md: 9 },
									_react2.default.createElement(
										_reactBootstrap.InputGroup,
										null,
										_react2.default.createElement(_reactBootstrap.FormControl, {
											className: "form-control",
											placeholder: "Password",
											type: "password",
											onKeyDown: this.handleKeys.bind(this),
											inputRef: function inputRef(ref) {
												_this2.login_password = ref;
											}
										}),
										_react2.default.createElement(
											_reactBootstrap.InputGroup.Button,
											null,
											_react2.default.createElement(
												_reactBootstrap.Button
												// type={"submit"}
												,
												{ bsStyle: "success",
													onClick: this.handleLogin.bind(this)

												},
												_react2.default.createElement(_LoginIcon2.default, null),
												"Login"
											)
										)
									)
								)
							)
						)
					)
				)
			);
		}
	}]);

	return AuthLoginForm;
}(_react2.default.Component);

exports.default = (0, _redux.compose)((0, _reactRedux.connect)(function (state) {
	return {
		currentUser: state.currentUser
	};
}))(AuthLoginForm);